import { Injectable, inject, signal } from '@angular/core';
import {ApiCallsService} from './api-calls.service';

@Injectable({
  providedIn: 'root'
})
export class EditingService {
  private apiCalls = inject(ApiCallsService);

  readonly editMode = signal(false);

  toggleEditMode() {
    this.editMode.update(value => !value);
  }

  getPublished() {
    return this.apiCalls.getSettings();
  }
}

